<div class="centre-competence-wrapper">
  <div class="header">
    <h2 class="title">Administration Centre de Compétence</h2>
  </div>

  <div class="menu-grid">
    <a
      *ngFor="let section of sections"
      class="box"
      [style.background-color]="theme.getColor('Main Dark')"
      (click)="navigate(section.route)"
    >
      <div class="box-icon">
        <mat-icon>{{ section.icon }}</mat-icon>
      </div>
      <div class="box-label">{{ section.label }}</div>
    </a>
  </div>
</div>
